<app-lms-modal-frame [title]="rejectOfferInfo?.loanStatus === 'Submitted' ? 'Cancel Offer Reason' : 'Reject Offer Reason'" [pageHeadWidth]="700">
  <div modal-body>
    <div class="card">
      <div class="card-body p-1">
        <form [formGroup]="rejectOfferReasonDetailsForm" #formDirective="ngForm">
          <table class="table table-borderless table-sm shadow-2-strong rounded-1 p-1">
            <caption>{{ rejectOfferInfo?.loanStatus === 'Submitted' ? 'Cancel Reason' : 'Reject Reason' }}</caption>
            <tbody>
              <tr class="text-center">
                <td>
                  <div class="d-flex flex-wrap flex-column jus align-content-center">
                    <label class="form-label mb-1 fw-bold">Client requires Rejection Letter?</label>
                    <div class="justify-content-center input-group mb-1">
                       <div class="justify-content-center">
                        <div class="radio-group-validation" role="radiogroup" aria-label="Requires rejection letter">
                          <div class="form-check mb-0">
                            <input id="requiresRejectionLetterYes" class="form-check-input" type="radio" formControlName="requiresRejectionLetter" [value]="'Yes'">
                            <label class="form-check-label" for="requiresRejectionLetterYes">Yes</label>
                          </div>
                          <div class="form-check mb-0">
                            <input id="requiresRejectionLetterNo" class="form-check-input" type="radio" formControlName="requiresRejectionLetter" [value]="'No'">
                            <label class="form-check-label" for="requiresRejectionLetterNo">No</label>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Validation message -->
                    <div *ngIf="rejectOfferReasonDetailsForm.invalid && submitted" class="validation-error text-center mt-1">
                      <div *ngIf="requiresRejectionLetter?.hasError('required')">
                        <small class="text-danger">
                          Confirm if the user requires {{ rejectOfferInfo?.loanStatus === 'Submitted' ? 'cancellation' : 'rejection' }} letter to be printed
                        </small>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr class="text-center">
                <td class="fw-bold">
                  {{ rejectOfferInfo?.loanStatus === 'Submitted' ? 'Please select cancellation reason' : 'Please select rejection reason' }}
                </td>
              </tr>
              <tr>
                <td>
                  <span class="d-flex flex-wrap flex-column align-content-center">
                    <!-- Multi-select component -->
                    <div class="multi-select-container w-100">
                      <div class="options-container">
                        <div *ngFor="let reason of lstReasonCode" class="option-item">
                          <label class="option-label">
                            <input
                              type="checkbox"
                              [value]="reason.reasonCode"
                              (change)="onOptionChange($event, reason)"
                              [checked]="isSelected(reason)"
                              class="option-checkbox">
                            <span class="option-text">{{ reason.description }}</span>
                          </label>
                        </div>
                      </div>

                      <!-- Selected items display -->
                      <div *ngIf="selectedReasons.length > 0" class="selected-items mt-1">
                        <h6 class="mb-1">Selected Reasons:</h6>
                        <div class="selected-tags">
                          <span *ngFor="let reason of selectedReasons" class="selected-tag">
                            {{ reason.description }}
                          </span>
                        </div>
                      </div>

                      <!-- Validation message -->
                      <div *ngIf="rejectOfferReasonDetailsForm.invalid && submitted" class="validation-error text-center mt-1">
                        <div *ngIf="rejectOfferReason?.hasError('required')">
                          <small class="text-danger">
                            A reason is required to {{ rejectOfferInfo?.loanStatus === 'Submitted' ? 'cancel' : 'reject' }} this offer
                          </small>
                        </div>
                      </div>
                    </div>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </form>
      </div>
    </div>
  </div>
  <div modal-actions class="flex-container">
    <button type="button" class="btn btn-primary btn-sm" (click)="close()">Close</button>
    <button type="button" class="btn btn-primary btn-sm" mdbRipple (click)="saveRejectOfferReason()">Save</button>
  </div>
</app-lms-modal-frame>
